"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toProspectPortalHomeUrl = toProspectPortalHomeUrl;
/** Prospect portal home URL — origin only (protocol + host [+ port]). */
function toProspectPortalHomeUrl(raw) {
    var trimmed = raw.trim();
    if (!trimmed)
        return '';
    try {
        return new URL(trimmed).origin;
    }
    catch (_a) {
        return trimmed;
    }
}
